import { useCallback, useEffect, useRef, useState } from 'react';

export const useABTest = (experimentId) => {
  const [variant, setVariant] = useState(false);
  const interval = useRef();

  const getVariant = useCallback(() => {
    if (window.google_optimize !== undefined) {
      const variant = window.google_optimize.get(experimentId);
      setVariant(variant === '1');
      clearInterval(interval.current);
    }
  }, [experimentId]);

  useEffect(() => {
    if (experimentId) {
      interval.current = setInterval(() => {
        getVariant();
      }, 100);
    }

    return () => clearInterval(interval.current);
  }, [experimentId, getVariant]);

  return variant;
};
